import gql from 'graphql-tag'

export const RESOLUTION_REPORT = gql`
  query resolutionReport($startDate: Date!, $endDate: Date!, $filters: GenericScalar) {
    resolutionReport(startDate: $startDate, endDate: $endDate, filters: $filters)
  }
`